
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/products",
      function () {
        return require("private-next-pages/stores/[cName]/products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/products"])
      });
    }
  